class MultiFactorAuthentication {
    constructor() {
        this.initCheckboxActions();
        this.totpTimeout();
        this.sessionTimeout();
        this.saveChangesBtn();
        this.ajaxForms();

        this.wasPinEnabled = this.checkPinInputs();
        this.wasMfaEnabled = this.checkMfaInputs();
    }
    checkPinInputs(){
        const clientAppMfaForm = document.getElementById('frm-mfaAppSettingsForm-mfaAppSettingsForm');

        if(clientAppMfaForm){
            let pinOnLoad = clientAppMfaForm.querySelector('input[name="pin_on_load"]');
            let pinEachConnection = clientAppMfaForm.querySelector('input[name="pin_each_connection"]');

            if(pinOnLoad && pinEachConnection){
                return pinOnLoad.checked || pinEachConnection.checked;
            }
        }
        return false;
    }
    checkMfaInputs(){
        const clientAppMfaForm = document.getElementById('frm-mfaAppSettingsForm-mfaAppSettingsForm');

        if(clientAppMfaForm){
            return clientAppMfaForm.querySelector('input[name="two_fa_application_login"]').checked ||
                clientAppMfaForm.querySelector('input[name="two_fa_each_connection"]').checked;
        }
        return false;
    }
    initCheckboxActions(){
        const thisClass = this;
        const controlPanelMfaForm = document.getElementById('frm-mfaCpSettingsForm-mfaCpSettingsForm');
        const clientAppMfaForm = document.getElementById('frm-mfaAppSettingsForm-mfaAppSettingsForm');
        const sessionTimeoutForm = document.getElementById('frm-sessionTimeoutForm-sessionTimeoutForm');

        if(clientAppMfaForm){
            const checkboxes = clientAppMfaForm.querySelectorAll('input[type="checkbox"]');
            const clientAppEachConnection = Array.from(checkboxes).find(checkbox => checkbox.name === 'two_fa_each_connection');
            const clientAppLogin = Array.from(checkboxes).find(checkbox => checkbox.name === 'two_fa_application_login');
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    new LeavePageDialog(true);
                    if(checkbox.attributes.name.value === 'two_fa_each_connection'){
                        if(checkbox.checked){
                            enableOrDisableTotpTimeout(false);
                        } else if(!clientAppLogin.checked){
                            enableOrDisableTotpTimeout(true);
                        }
                    } else if(checkbox.attributes.name.value === 'two_fa_application_login'){
                        if(checkbox.checked){
                            enableOrDisableTotpTimeout(false);
                        } else if(!clientAppEachConnection.checked){
                            enableOrDisableTotpTimeout(true);
                        }
                    }
                    thisClass.enablePulsing();
                })
            });
        }

        const enableOrDisableTotpTimeout = (disable) => {
            const totpTimeoutCheckbox = clientAppMfaForm.querySelector('input[name="two_fa_session_timeout_checkbox"]');
            totpTimeoutCheckbox.disabled = disable;
            if(disable){
                totpTimeoutCheckbox.checked = false;
                const totpTimeoutDialerControls = document.querySelectorAll('[data-kt-dialer-disabled="true"]');
                totpTimeoutDialerControls.forEach(totpTimeoutDialerControl => {
                    totpTimeoutDialerControl.disabled = true;
                });
            }
        }

        if(controlPanelMfaForm){
            const checkboxes = controlPanelMfaForm.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    thisClass.enablePulsing();
                })
            });
        }

        if(sessionTimeoutForm){
            const checkboxes = sessionTimeoutForm.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    thisClass.enablePulsing();
                })
            });
        }
    }
    enablePulsing(){
        // Set Save Changes button active
        const saveChangesBtn = document.getElementById('saveChangesBtn');
        if(saveChangesBtn){
            saveChangesBtn.disabled = false;
            let pulseBtn = document.getElementById('saveChangesPulse');
            if(!pulseBtn){
                let pulseBtn = document.createElement("span");
                pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                pulseBtn.id = 'saveChangesPulse';
                saveChangesBtn.appendChild(pulseBtn);
            }
        }
    }
    saveChangesBtn(){
        const thisClass = this;
        let saveChangesBtn = document.getElementById('saveChangesBtn');
        if(saveChangesBtn){
            saveChangesBtn.addEventListener('click', function (event) {
                event.preventDefault();
                if (event.currentTarget.disabled === false) {
                    let totp = !thisClass.wasMfaEnabled && thisClass.checkMfaInputs();
                    let pin = !thisClass.wasPinEnabled && thisClass.checkPinInputs();
                    Swal.fire({
                        html: `
                            <div class="text-center text-primary">Are you sure you want to save these settings? </div>`+
                            (totp ?
                                '<div class="text-center text-primary mt-5">' +
                                '   <b>Note</b>: Members who do not have TOTP '+(pin ? 'or PIN ' : '')+'set will be disconnected.' +
                                '</div>' : '')+
                            (pin && !totp ?
                                '<div class="text-center text-primary mt-5">' +
                                '   <b>Note</b>: Members who do not have a PIN set will be disconnected.' +
                                '</div>' : ''),
                        icon: "warning",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        reverseButtons: true,
                        showCancelButton: true,
                        confirmButtonText: "Save changes",
                        cancelButtonText: "Cancel",
                        customClass: {
                            confirmButton: "btn btn-danger mt-0",
                            cancelButton: 'btn btn-light-primary mt-0',
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            new bootstrap.Modal(document.getElementById('loading-modal')).show();
                            let mfaAppSettingsForm = $('#frm-mfaAppSettingsForm-mfaAppSettingsForm');
                            mfaAppSettingsForm.submit();
                        }
                    });
                }
            });

            const tabs = document.querySelectorAll('.nav-link[data-bs-toggle="tab"]');
            tabs.forEach((tab) => {
                tab.addEventListener('click', function () {
                    if(this.attributes['data-show-save-changes'].value === 'true'){
                        saveChangesBtn.classList.remove('d-none');
                    } else {
                        saveChangesBtn.classList.add('d-none');
                    }
                })
            });
        }
    }
    ajaxForms(){
        $.nette.ext('saveChangesForms', {
            success: function (payload, status, jqXHR, settings) {
                let formID = settings.nette.form[0].attributes.id.value;
                if(formID === 'frm-mfaAppSettingsForm-mfaAppSettingsForm'){
                    let mfaCpSettingsForm = $('#frm-mfaCpSettingsForm-mfaCpSettingsForm');
                    mfaCpSettingsForm.submit();
                } else if(formID === 'frm-mfaCpSettingsForm-mfaCpSettingsForm'){
                    let mfaCpSettingsForm = $('#frm-sessionTimeoutForm-sessionTimeoutForm');
                    mfaCpSettingsForm.submit();
                } else if(formID === 'frm-sessionTimeoutForm-sessionTimeoutForm'){
                    bootstrap.Modal.getInstance(document.getElementById('loading-modal')).hide();
                    toastr.success('Changes have been saved.');

                    document.getElementById('saveChangesPulse').remove();
                    document.getElementById('saveChangesBtn').disabled = true;
                    new LeavePageDialog(false);
                }
            }
        });
    }
    totpTimeout() {
        const thisClass = this;
        const totpTimeoutDialer = document.querySelector("#session-timeout-dialer");
        const totpTimeoutDialerControls = totpTimeoutDialer.querySelectorAll('[data-kt-dialer-disabled="true"]');
        const totpTimeoutCheckbox = document.querySelector("#session-timeout-checkbox");
        const totpTimeoutInput = document.querySelector("input[name=two_fa_session_timeout]");
        totpTimeoutCheckbox.addEventListener('change', function () {
            totpTimeoutDialerControls.forEach(totpTimeoutDialerControl => {
                totpTimeoutDialerControl.disabled = !totpTimeoutCheckbox.checked;
            });
        });
        const dialerObject = new KTDialer(totpTimeoutDialer, {
            min: 10,
            max: 240,
            step: 10,
            suffix: " minutes",
            decimals: 0
        });
        dialerObject.on('kt.dialer.changed', function(){
            thisClass.enablePulsing();
            totpTimeoutInput.value = thisClass.convertToHoursAndMinutes(dialerObject.getValue());
        });
        totpTimeoutInput.value = thisClass.convertToHoursAndMinutes(dialerObject.getValue());
    }
    sessionTimeout() {
        const thisClass = this;
        const loginTimeoutDialer = document.querySelector("#login-timeout-dialer");
        const loginTimeoutDialerControls = loginTimeoutDialer.querySelectorAll('[data-kt-dialer-login-timeout-disabled="true"]');
        const loginTimeoutCheckbox = document.querySelector("#login-timeout-checkbox");
        const loginTimeoutInput = document.querySelector("input[name=login_timeout]");
        loginTimeoutCheckbox.addEventListener('change', function () {
            loginTimeoutDialerControls.forEach(loginTimeoutDialerControl => {
                loginTimeoutDialerControl.disabled = !loginTimeoutCheckbox.checked;
            });
        });
        const dialerObject = new KTDialer(loginTimeoutDialer, {
            min: 30,
            max: 1440,
            step: 30,
            suffix: " minutes",
            decimals: 0
        });
        dialerObject.on('kt.dialer.changed', function(){
            thisClass.enablePulsing();
            loginTimeoutInput.value = thisClass.convertToHoursAndMinutes(dialerObject.getValue());
        });
        loginTimeoutInput.value = thisClass.convertToHoursAndMinutes(dialerObject.getValue());
    }
    convertToHoursAndMinutes(timeString) {
        let hours = 0;
        let minutes = 0;

        const hourMatch = timeString.match(/(\d+)\s*h/);
        const minuteMatch = timeString.match(/(\d+)\s*min/);
        const onlyMinutesMatch = timeString.match(/^(\d+)\s*minutes$/);


        if (hourMatch) {
            hours = parseInt(hourMatch[1], 10);
        }

        if (minuteMatch) {
            minutes = parseInt(minuteMatch[1], 10);
        }

        if (onlyMinutesMatch) {
            let totalMinutes = parseInt(onlyMinutesMatch[1], 10);
            hours = Math.floor(totalMinutes / 60);
            minutes = totalMinutes % 60;
        }

        return (hours > 0 ? hours+'h' : '')+(hours > 0 ? ' '+minutes+'min' : minutes+' minutes');
    }
}
window.MultiFactorAuthentication = MultiFactorAuthentication;